<!--
 * @Description: 
 * @Date: 2021-02-03 11:29:09
-->
<template>
  <ul v-if="list.length">
    <li v-for="item in list" :key="item.id" @click="jump(item)">
      <img :src="item.coverPicUrl" alt />
      <p class="text-overflow-1">{{ item.courseName }}</p>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'LivingRela',
  inject: ['livingStore'],
  data() {
    return {
      guanLianList: []
    };
  },
  computed: {
    list() {
      return this.livingStore.rela.filter(item => item.courseName);
    }
  },
  methods: {
    jump(item) {
      let { href } = this.$router.resolve({
        name: 'liveDetail',
        params: { id: item.id }
      });
      window.location.href = href;
    }
  }
};
</script>

<style scoped lang="scss">
ul {
  width: 100%;
  overflow-x: auto;
  display: flex;
  padding: 0.27rem 0.2rem;
  &::-webkit-scrollbar {
    display: none;
  }
  li {
    flex-shrink: 0;
    width: 3.76rem;
    margin-right: 0.17rem;
    // flex: 1 0 auto;
    img {
      width: 3.76rem;
      height: 2.11rem;
      border-radius: 0.16rem;
    }
    p {
    }
  }
}
</style>
